import { c as _c } from "react/compiler-runtime";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
interface ClubFilterLocationItemProps {
  location: {
    address: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
  };
  onSelect: (location: {
    address: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
  }) => void;
}
export default function ClubFilterLocationItem(t0) {
  const $ = _c(15);
  const {
    location,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== location || $[1] !== onSelect) {
    t1 = () => onSelect(location);
    $[0] = location;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FmdGoodOutlinedIcon />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== location.address) {
    t3 = <p>{location.address} </p>;
    $[4] = location.address;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== location.city || $[7] !== location.zipCode) {
    t4 = <p className="text-grey text-sm">{location.zipCode} - {location.city}</p>;
    $[6] = location.city;
    $[7] = location.zipCode;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col justify-center items-start ml-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <div className="flex flex-row justify-start items-center hover:cursor-pointer hover:bg-light-grey px-4 py-2" onClick={t1}>{t2}{t5}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}